import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import cccApi from '../api/cccApi';

const getToken = () =>
  localStorage.getItem('jwt_token') || localStorage.getItem('access_token');

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const [denyMessage, setDenyMessage] = useState<string | null>(null);

  const token = getToken();

  useEffect(() => {
    if (!token) {
      setAllowed(null);
      setDenyMessage(null);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await cccApi.validateCccAccess();
        if (cancelled) return;
        if (res?.allowed === true) {
          setAllowed(true);
          setDenyMessage(null);
        } else {
          setAllowed(false);
          setDenyMessage(res?.message || 'Acesso reservado ao CallCenter Comercial e Comercial');
        }
      } catch (err: unknown) {
        if (cancelled) return;
        console.error('[CCC] validate access failed', err);
        setAllowed(false);
        setDenyMessage(
          'Não foi possível validar o acesso. Confirme que o backend CCC está a correr (:5001).'
        );
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, location.pathname]);

  if (!token) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" replace state={{ from: returnTo }} />;
  }

  if (allowed === null) {
    return <div style={{ padding: 48, textAlign: 'center' }}>A validar acesso...</div>;
  }

  if (!allowed) {
    return (
      <div style={{ padding: 48, textAlign: 'center', maxWidth: 480, margin: '0 auto' }}>
        <h2>Sem permissão</h2>
        <p>{denyMessage}</p>
        <p style={{ marginTop: 16, fontSize: 13, color: '#6b7280' }}>
          Utilize uma conta do tenant CCC/Comercial ou contacte o administrador.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
